import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

// Global error handlers
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
  
  // Don't show error UI for AbortError
  if (event.error?.name === 'AbortError') {
    console.log('AbortError caught globally, not showing error UI');
    event.preventDefault();
    return;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  
  // Don't show error UI for AbortError
  if (event.reason?.name === 'AbortError') {
    console.log('AbortError promise rejection caught globally, not showing error UI');
    event.preventDefault();
    return;
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
); 